import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import GenreGrid from './components/GenreGrid';
import HotSeries from './components/HotSeries';
import RegionSection from './components/RegionSection';
import ClassicSection from './components/ClassicSection';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import { guomanSeries, rimanSeries } from '@/mocks/comicData';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  const [keyword, setKeyword] = useState('');

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero onSearch={setKeyword} />
        <GenreGrid />
        <HotSeries keyword={keyword} />
        <RegionSection
          id="guoman"
          kicker="国漫专区"
          title="国产漫画，本土味道"
          subtitle="武侠古风、都市职场、现代悬疑，国漫原创佳作一网打尽，分类直达。"
          items={guomanSeries}
          icon="ri-palette-line"
          showType={false}
          tone="primary"
          bg="bg-background-100"
        />
        <RegionSection
          id="riman"
          kicker="日漫专区"
          title="海外经典，风格多元"
          subtitle="恋爱、奇幻、治愈、科幻，日漫热门与经典作品按题材分类呈现。"
          items={rimanSeries}
          icon="ri-globe-line"
          showType={false}
          tone="accent"
          bg="bg-background-50"
        />
        <ClassicSection />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}